import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../pages/Auth/login";
import { RedirectAuthorized } from "../utils/authRedirectHandlers";

export const PublicLayout = () => {
  return (
    <RedirectAuthorized>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="signUp" element={<h1>SUP</h1>} />

        <Route path="/*" element={<Navigate to="/404" replace />} />
      </Routes>
    </RedirectAuthorized>
  );
};
